import React, { useState, useEffect } from 'react';

import { Form, Input, Rate } from 'antd';
import ContactStore from 'stores/ContactStore';
type IProps = { form: any };
interface FeedBackProps {
    name: string;
    question: string;
    type: string;
}

const SalesQuestions: React.FC<IProps> = ({ form }) => {
    const [loading, setLoading] = useState(true);
    const [feedbackQuestions, setFeedbackQuestions] = useState<FeedBackProps[]>([]);

    useEffect(() => {
        const fetchFeedbackQuestions = async () => {
            setLoading(true);
            await ContactStore.getFeedbackQuestions();
            setFeedbackQuestions(ContactStore.feedback_questions || []);
            setLoading(false);
        };

        fetchFeedbackQuestions();
    }, []);
    return (
        <>
            {loading ? (
                <p>Loading feedback questions...</p>
            ) : (
                feedbackQuestions.map((feedback: FeedBackProps) => (
                    <Form.Item
                        key={feedback?.name}
                        label={
                            feedback?.type === 'rating'
                                ? `${feedback?.question} (1=Not at all satisfied, 10=Extremely satisfied)`
                                : feedback?.question
                        }
                        name={feedback?.question}
                        rules={[{ required: feedback?.type === 'rating', message: 'Please rate us' }]}
                    >
                        {feedback?.type === 'rating' ? (
                            <Rate count={10} />
                        ) : (
                            <Input.TextArea
                                rows={4}
                                placeholder="Your feedback here...(Max: 500 characters)"
                                maxLength={500}
                            />
                        )}
                    </Form.Item>
                ))
            )}
        </>
    );
};

export default SalesQuestions;
